import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { OrderByDirection } from 'firebase/firestore';
import type { UserAccountFilterItem } from './usersApi';
import { getDefaultUserAccountPageSize } from './userAccountQueryCapabilities';

export interface UserAccountQueryState {
  filters: UserAccountFilterItem[];
  page: number;
  pageSize: number;
  sortField?: string | null;
  sortDir?: OrderByDirection;
}

export type UserQueryState = UserAccountQueryState;

const initialState: UserAccountQueryState = {
  filters: [],
  page: 0,
  pageSize: getDefaultUserAccountPageSize(),
  sortField: 'createdAt', // Default sort for users
  sortDir: 'desc',
};

const userAccountQuerySlice = createSlice({
  name: 'userAccountQuery',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<UserAccountFilterItem[]>) {
      state.filters = action.payload;
      state.page = 0;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
      state.page = 0;
    },
    setSort(state, action: PayloadAction<{ field?: string | null; dir?: OrderByDirection }>) {
      state.sortField = action.payload.field;
      state.sortDir = action.payload.dir;
    },
  },
});

export const { setFilters, setPage, setPageSize, setSort } = userAccountQuerySlice.actions;
export default userAccountQuerySlice.reducer;
